import { createContext, useState, useContext } from 'react';

const AuthContext = createContext();

function getSubdominio() {
  const host = window.location.hostname;
  const parts = host.split('.');
  // Ignorar subdominios reservados
  const subdominiosReservados = ['app', 'www', 'mail', 'localhost'];
  if (parts.length > 2 && !subdominiosReservados.includes(parts[0])) {
    return parts[0];
  }
  return null;
}

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(
    JSON.parse(localStorage.getItem('usuario')) || null
  );

  const subdominio = getSubdominio();

  const login = (datos) => {
    setUsuario(datos);
    localStorage.setItem('usuario', JSON.stringify(datos));
  };

  const logout = () => {
    setUsuario(null);
    localStorage.removeItem('usuario');
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout, subdominio }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}